import React, { ReactNode } from "react";

interface AuthFormComponentProps {
    header: string;
    description: string;
    title: string;
    children: ReactNode;
  }

  const AuthFormComponent: React.FC<AuthFormComponentProps> = ({
    header,
    description,
    title,
    children,
  }) => {
  return (
    <div className="page-container">
      <div className="login-container row">
        {/* Left Side */}
        <div className="left-side col-md-6 d-none d-md-flex">
          <div>
            <center>
              <h1>{header}</h1>
            </center>
            <p>{description}</p>
          </div>
        </div>

        {/* Right Side */}
        <div className="login-form col-12 col-md-6">
          <h3 className="mb-4">{title}</h3>
          {children}
        </div>
      </div>
    </div>
  );
};

export { AuthFormComponent };

